import { React, useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useRoutes } from 'hookrouter';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Routes from '../routes/routes';
import {
  Box,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Paper,
  FormControlLabel,
  MenuItem,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SendIcon from '@material-ui/icons/Send';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { v4 as uuidv4 } from 'uuid';
import CloudIcon from '@material-ui/icons/Cloud';
import DownloadIcon from '@material-ui/icons/GetApp';
import SearchIcon from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';
import MuiAlert from '@material-ui/lab/Alert';
import SaveIcon from '@material-ui/icons/Save';

import axios from 'axios';
import {
  getExisitingTemplates,
  getSpecificTemplates,
  setUploadSelector,
  getSelectedTemplateSelector,
  setInstanceSelector,
  getInstanceById,
  createInstance,
  setCreateInstanceSelector,
  resetUploadStates,
  setAllInstancesSelector,
  createInstanceMultiple,
  setRowsInsertedSelector,
} from '../../services/uploadSlice';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import TablePagination from '@material-ui/core/TablePagination';
import * as XLSX from 'xlsx';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import {
  addTemplate,
  createTemplateId,
  setNewTemplateIdSelector,
  setTypeSelector,
  resetTemplateStates,
  setCreateTemplateSelector,
  toggleActive,
  setToggleResponse,
  setActiveToggleSelector,
  setZipPreferenceSelector,
  updateTemplate,
  setUpdateSelector,
  toggleZipPreference,
} from '../../services/templateSlice';
import { navigate } from 'hookrouter';
import NavBar from '../NavBar/navbar';
import EditIcon from '@material-ui/icons/Edit';
import { DataGrid } from '@mui/x-data-grid';

const Alert = (props) => {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
  outer: {
    margin: theme.spacing(5),
    padding: theme.spacing(1),
    textAlign: 'left !important',
  },
  searchBox: {
    marginTop: '10px',
    marginBottom: '10px',
    marginLeft: '10px',
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  pos: {
    marginBottom: 12,
  },
  textfield: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  gridpaper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  fieldpos: {
    fontSize: '20px',
  },
  paper: {
    padding: theme.spacing(1),
  },
  dialogBox: {
    padding: theme.spacing(1),
    textAlign: 'center',
  },
  header: {
    margin: theme.spacing(2),
  },
  btn: {
    margin: theme.spacing(3),
  },
  root: {
    padding: theme.spacing(3),
    '& .MuiFormControl-root': {
      width: '100%',
      textAlign: 'left',
      padding: '0',
    },
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export const EditTable = (props) => {
  const api = '/api/';

  const classes = useStyles();
  const [pageWiseData, setPageWiseData] = useState({});
  const [instances, setInstances] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [requiredPageNumber, setRequiredPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchData, setSearchData] = useState('');
  const [selection, setSelection] = useState([]);
  const [confirmDeletetionDialogOpen, setConfirmDeletionDialogOpen] = useState(false);
  const [confirmSaveDialogOpen, setConfirmSaveDialogOpen] = useState(false);
  const [dataToBeUpdated, setDataToBeUpdated] = useState([]);
  const [originalPageData, setOriginalPageData] = useState({});

  useEffect(() => {
    loadInstancedData();
  }, [searchData]);

  useEffect(() => {
    if (instances && instances.length && !(requiredPageNumber in pageWiseData)) {
      setDataLoading(true);
      const url =
        api +
        'instanceattribute/forinstance/multiple?instanceIds=' +
        instances.slice(requiredPageNumber * pageSize, requiredPageNumber * pageSize + pageSize);
      axios.get(url).then((response) => {
        const data = response.data;
        const items = data
          .map((item) => {
            return {
              id: item.id,
              key: item.templateAttribute.name,
              value: item.content,
              instanceId: item.instance.id,
            };
          })
          .reduce(
            (result, item) => ({
              ...result,
              [item.instanceId]: [...(result[item.instanceId] || []), item],
            }),
            {},
          );
        setPageWiseData({ ...pageWiseData, [requiredPageNumber]: items });
        setOriginalPageData(
          JSON.parse(JSON.stringify({ ...pageWiseData, [requiredPageNumber]: items })),
        );
        setDataLoading(false);
      });
    }
  }, [instances, requiredPageNumber, pageSize]);

  const loadInstancedData = () => {
    let data = {};
    setPageWiseData({});
    setDataLoading(true);
    console.log(searchData);
    data['attributeSearchItems'] = [
      { attributeName: '', searchString: searchData || '', isGlobal: true },
    ];
    data['templateId'] = props.templateId;
    axios
      .post(api + 'instance/search/category/multiple/v4/' + props.customerId, data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        setInstances(response.data.instanceIds);
        setDataLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteSelectedRecords = () => {
    setDataLoading(true);
    axios
      .delete(api + 'instance/multiple', {
        data: selection,
      })
      .then(() => {
        setConfirmDeletionDialogOpen(false);
        loadInstancedData();
        setSelection([]);
      });
  };

  const saveUpdatedRecords = () => {
    setDataLoading(true);
    axios
      .post(
        api + 'instanceattribute/update/multiple',
        Object.values(dataToBeUpdated).map((item) => ({
          instanceId: item[0],
          name: item[1],
          newContent: item[2],
        })),
      )
      .then(() => {
        setConfirmSaveDialogOpen(false);
        loadInstancedData();
        setDataToBeUpdated([]);
      });
  };

  const changePageSize = (ps) => {
    console.log('changePageSize called');
    setPageWiseData({});
    setPageSize(ps);
    setRequiredPageNumber(0);
  };

  const getColumns = () => {
    return requiredPageNumber in pageWiseData
      ? Object.values(pageWiseData[requiredPageNumber])[0].map((item) => ({
          field: item.key,
          minWidth: 150,
          flex: 1,
          editable: true,
          hideSortIcon: true,
          renderCell: (params) => {
            // if(params.id == "745504" && params.field == "DEALER_NUM") console.log(params)
            if (JSON.stringify([params.id, params.field]) in dataToBeUpdated) {
              return <strong>{params.value}</strong>;
            } else {
              return <span>{params.value}</span>;
            }
          },
        }))
      : [];
  };

  const getRows = () => {
    return requiredPageNumber in pageWiseData
      ? Object.entries(pageWiseData[requiredPageNumber]).map((item) => {
          return item[1].reduce(
            (result, data) => ({
              ...result,
              [data.key]: data.value,
            }),
            { id: item[0] },
          );
        })
      : [];
  };

  const updateCell = (instanceId, field, newValue) => {
    axios
      .post(api + '/instanceattribute/update/', {
        instanceId: instanceId,
        name: field,
        newContent: newValue,
      })
      .then((response) => {
        console.log(response.data);
      });
  };

  const checkCellForUpdate = (instanceId, field, newValue) => {
    // console.log(dataToBeUpdated, "before")
    const pageWiseDataCopy = { ...pageWiseData };
    const oldValueIndex = originalPageData[requiredPageNumber][instanceId].findIndex(
      (item) => item.key === field,
    );
    const oldValue = originalPageData[requiredPageNumber][instanceId][oldValueIndex].value;
    let dataToBeUpdatedCopy = { ...dataToBeUpdated };
    console.log(dataToBeUpdated, 'before', oldValue);

    let shouldUpdate = false;
    if (oldValue !== newValue) {
      shouldUpdate = true;
      dataToBeUpdatedCopy[JSON.stringify([instanceId, field])] = [instanceId, field, newValue];
      pageWiseDataCopy[requiredPageNumber][instanceId][oldValueIndex].value = newValue;
      // setPageWiseData(pageWiseDataCopy)
    } else if (JSON.stringify([instanceId, field]) in dataToBeUpdatedCopy) {
      shouldUpdate = true;
      delete dataToBeUpdatedCopy[JSON.stringify([instanceId, field])];
      pageWiseDataCopy[requiredPageNumber][instanceId][oldValueIndex].value = newValue;
    }

    if (shouldUpdate) setDataToBeUpdated(dataToBeUpdatedCopy);
    console.log(dataToBeUpdatedCopy, 'after');
  };

  const searchClicked = () => {
    if (searchData != searchTextRef.current.value) {
      setSearchData(searchTextRef.current.value);
    }
  };

  const searchTextRef = useRef();

  return (
    <>
      <NavBar />
      <Box className={classes.outer} boxShadow={5}>
        <Grid container justifyContent="left">
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <h1>Editable Data View</h1>
          </Grid>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              label="Search"
              className={classes.searchBox}
              size="small"
              inputRef={searchTextRef}
              disabled={dataLoading}
            />
            <Button
              disableTouchRipple={true}
              className={classes.searchBox}
              onClick={() => searchClicked()}
            >
              <SearchIcon size="small" />
            </Button>
          </Grid>
          <Grid item xs={4} />
          <Grid item xs={4} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <Button
              disabled={!(selection && selection.length)}
              color="secondary"
              className={classes.searchBox}
              variant="outlined"
              startIcon={<DeleteIcon></DeleteIcon>}
              onClick={() => setConfirmDeletionDialogOpen(true)}
            >
              Delete
            </Button>
            <Button
              disabled={!(dataToBeUpdated && Object.keys(dataToBeUpdated).length)}
              color="primary"
              className={classes.searchBox}
              variant="outlined"
              startIcon={<SaveIcon></SaveIcon>}
              onClick={() => setConfirmSaveDialogOpen(true)}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <div style={{ maxHeight: '77vh', width: '100%', overflow: 'auto' }}>
          <DataGrid
            pageSize={pageSize}
            onPageSizeChange={(ps) => changePageSize(ps)}
            rowsPerPageOptions={[5, 10, 20]}
            pagination
            checkboxSelection
            disableSelectionOnClick
            autoHeight
            onSelectionModelChange={(ns) => {
              console.log(ns);
              setSelection(ns);
            }}
            paginationMode="server"
            onPageChange={(newPage) => setRequiredPageNumber(newPage)}
            page={requiredPageNumber}
            loading={dataLoading}
            columns={getColumns()}
            rows={getRows()}
            rowCount={instances.length}
            onCellEditCommit={({ id, field, value }) => {
              checkCellForUpdate(id, field, value); /*updateCell(id, field, value)*/
            }}
          />
        </div>

        <Dialog open={confirmDeletetionDialogOpen}>
          <DialogTitle>Delete {selection.length == 1 ? 'record' : 'records'}</DialogTitle>
          <DialogContent>
            Are you sure you want to delete the selected{' '}
            {selection.length == 1 ? 'record' : selection.length + ' records'}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmDeletionDialogOpen(false)}>Cancel</Button>
            <Button onClick={() => deleteSelectedRecords()}>Yes</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={confirmSaveDialogOpen}>
          <DialogTitle>
            Save {Object.values(dataToBeUpdated).length == 1 ? 'record' : 'records'}
          </DialogTitle>
          <DialogContent>
            Are you sure you want to save the updated{' '}
            {Object.values(dataToBeUpdated).length == 1
              ? 'record'
              : Object.values(dataToBeUpdated).length + ' records'}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmSaveDialogOpen(false)}>Cancel</Button>
            <Button onClick={() => saveUpdatedRecords()}>Yes</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};
